import React, { Component, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Main from "./main";            // เดสก์ท็อป
import MainMobile from "./mainindex"; // มือถือ (ไฟล์ที่คุณมี)
import Logout from "./logout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/** ตรวจมือถือแบบเบาๆ + กว้างหน้าจอ */
const isMobileUA = () => /android|iphone|ipad|ipod|mobile/i.test(navigator.userAgent || "");
const isNarrow  = () => window.matchMedia?.("(max-width: 768px)").matches;

/** Gate: ตัดสินใจว่าจะอยู่ / หรือ /m (รองรับ override) */
function DeviceGate({ children }) {
  const loc = useLocation();

  // override ผ่าน query ?view=desktop|mobile|auto
  const params = new URLSearchParams(loc.search);
  const qView = params.get("view");
  if (qView === "desktop" || qView === "mobile" || qView === "auto") {
    localStorage.setItem("viewMode", qView);
  }

  const stored = localStorage.getItem("viewMode"); // 'desktop' | 'mobile' | 'auto' | null
  const wantMobile =
    stored === "mobile"
      ? true
      : stored === "desktop"
      ? false
      : isMobileUA() || isNarrow(); // auto

  const underMobile = loc.pathname.startsWith("/mobile");

  // helper กัน // ซ้อน
  const join = (base, path) => {
    if (base.endsWith("/") && path.startsWith("/")) return base + path.slice(1);
    if (!base.endsWith("/") && !path.startsWith("/")) return base + "/" + path;
    return base + path;
  };

  if (wantMobile && !underMobile) {
    // ไป mobile พร้อมพาธ/คิวรีเดิม
    const to = join("/mobile", loc.pathname) + loc.search;
    return <Navigate to={to} replace />;
  }

  if (!wantMobile && underMobile) {
    // กลับ desktop: ตัด /mobile ออก
    const to = (loc.pathname.replace(/^\/mobile/, "") || "/") + loc.search;
    return <Navigate to={to} replace />;
  }

  return children;
}


class App extends Component {
  render() {
    return (
      <>
        <BrowserRouter>
          <DeviceGate>
            {/* <ViewSwitch />  // เปิดใช้ถ้าอยากให้ผู้ใช้สลับโหมดเองได้ */}
            <Suspense fallback={null}>
              <Routes>
                {/* มือถือ */}
                <Route path="/mobile/*" element={<MainMobile />} />
                {/* เดสก์ท็อป */}
                <Route path="/*" element={<Main />} />
                {/* เส้นทางออกจากระบบ */}
                <Route path="/logout" element={<Logout />} />
                 <Route path="/mobile/logout" element={<Logout />} />
                {/* กันหลงทาง */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
          </DeviceGate>
        </BrowserRouter>
        <ToastContainer />
      </>
    );
  }
}

export default App;
